import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]买入日期规则
 */
export function queryBuyDateRuleUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListTradeDateRuleDto> {
  return resource.postNoAuth('/fundTradeRule/queryBuyDateRule', req, config);
}

/**
 * [No Auth]买入费率规则
 */
export function queryBuyFeeRuleUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultTradeFeeRuleDto> {
  return resource.postNoAuth('/fundTradeRule/queryBuyFeeRule', req, config);
}

/**
 * [No Auth]买入最低费率vs折扣费率
 */
export function queryFundFeeUsingPOST(req: InfoCodeDto | void, config?: RequestConfig): Promise<ApiResultFundFeeDto> {
  return resource.postNoAuth('/fundTradeRule/queryFundFee', req, config);
}

/**
 * [No Auth]卖出日期规则
 */
export function querySellDateRuleUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListTradeDateRuleDto> {
  return resource.postNoAuth('/fundTradeRule/querySellDateRule', req, config);
}

/**
 * [No Auth]卖出费率规则
 */
export function querySellFeeRuleUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultTradeFeeRuleDto> {
  return resource.postNoAuth('/fundTradeRule/querySellFeeRule', req, config);
}
